import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './loading.module.css';

export default function LoadingButton({
  text,
  onClick,
  loadingMessage = 'AI Loading...',
}) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);
    try {
      await onClick(); // call the provided function (can be async)
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={loading}
      className={`${styles.button} ${loading ? styles.loading : ''}`}
    >
      {loading && <span className={styles.spinner} aria-hidden="true"></span>}
      {loading ? loadingMessage : text}
    </button>
  );
}

LoadingButton.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  loadingMessage: PropTypes.string,
};
